module.exports = __webpack_public_path__ + "static/media/groomingPageBathIcon.8b2dff43.png";